import React, { Component } from 'react';
import {MuiThemeProvider, createMuiTheme} from 'material-ui/styles';

import ShowenConf from '../ShowenConf';

import './App.css';

const theme = createMuiTheme({
  dialog: {
    titleFontSize: 18,
  },
});

class App extends Component {
  render() {
    return (
    <MuiThemeProvider muiTheme={theme}>
      <div className="App">
        <div className="App-header">
          <img src="/img/logo.png" alt="" style={{height: 32}} />
        </div>
        <ShowenConf />
      </div>
    </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js